(function() {
    'use strict';

    angular
        .module('app.calendarizaciones')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/calendarizaciones',
                config: {
                    templateUrl: 'app/calendarizaciones/calendarizaciones.html',
                    controller: 'Calendarizaciones',
                    controllerAs: 'vm',
                    title: 'Calendarizaciones'
                }
            },
            {
                url: '/editar-calendarizacion/:id?',
                config: {
                    templateUrl: 'app/calendarizaciones/editarCalendarizacion.html',
                    controller: 'EditarCalendarizacion',
                    controllerAs: 'vm',
                    title: 'EditarCalendarizacion'
                }
            }
        ];
    }
})();
